import React, { useState, useRef, useEffect } from 'react';

const ExpandableText = ({ text, maxLines = 2, useExpanded, onChange }) => {
    const [expanded, setExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        if (textRef.current) {
            // 检测文本是否溢出
            const isOverflowing = textRef.current.scrollHeight > 35;
            setShowButton(isOverflowing);
        }
    }, [text]);

    return (
        <div className="expandable-text" style={{position:'relative'}}>
            <div
                ref={textRef}
                className={`text-content ${expanded ? 'expanded' : ''}`}
                style={{
                    overflow: 'hidden',
                    maxHeight: expanded ? 'none' : `${maxLines * 35}px`
                }}
            >
                {text}
            </div>
            {showButton && (
                <div
                    style={{marginTop:'5px',color:'#3B70FF',fontSize:'12px'}}
                    className="expand-button"
                    onClick={() => {
                        if (useExpanded) setExpanded(!expanded);
                        onChange && onChange();
                    }}
                >
                    {expanded?'收起': '展开'}
                </div>
            )}
        </div>
    );
};

export default ExpandableText;
